import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { Message as MessageType } from '../types/Message';
import Message from './Message';

type Props = {
  messages: MessageType[];
};

const MessagesList = (props: Props) => {
  const messagesEndRef = React.useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  React.useEffect(() => {
    scrollToBottom();
  }, [props.messages.length]);

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        bgcolor: '#f6f6f6',
        '&::-webkit-scrollbar': { width: 4 },
        '&::-webkit-scrollbar-thumb': { bgcolor: '#bbb', borderRadius: 0 },
        '&::-webkit-scrollbar-track': { bgcolor: '#eee' },
      }}
    >
      <List sx={{ px: 2, py: 2 }}>
        {props.messages.map((message) => (
          <ListItem key={message.noteId} disablePadding sx={{ mb: 2 }}>
            <Message message={message} />
          </ListItem>
        ))}
      </List>
      <div ref={messagesEndRef} />
    </Box>
  );
};

export default MessagesList;
